import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT

function* getCouponList(actions) {

  let uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-coupons?page=" + actions.page
        : apiUrl + "/opa-coupons" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_COUPON_RESPONSE_GET", value: response });
  } catch (error) {

    yield put({ type: "LIST_COUPON_RESPONSE_GET", value: error });
  }
}

function* getCoupon(actions) {

  let uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-coupon/"
        : apiUrl + "/opa-coupon/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "COUPON_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "COUPON_RESPONSE_GET", value: error });
  }
}

function* createCoupon(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-coupon";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.created || response.id) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "COUPON_RESPONSE_CREATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "COUPON_RESPONSE_CREATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* updateCoupon(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-coupon/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PUT", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.id) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "COUPON_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });

  } catch (error) {
    yield put({
      type: "COUPON_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* getCouponCode(actions) {

  let uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-coupon-details/"
        : apiUrl + "/opa-coupon-details/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "COUPON_CODE_DETAIL_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "COUPON_CODE_DETAIL_RESPONSE_GET", value: error });
  }
}

function* updateCouponCode(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-coupon-details/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PUT", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status === true) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "COUPON_CODE_DETAIL_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });

  } catch (error) {
    yield put({
      type: "COUPON_CODE_DETAIL_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* resetCouponCode() {
  yield put({ type: "COUPON_CODE_DETAIL_RESPONSE_RESET" });
}

function* resetCoupon() {
  yield put({ type: "COUPON_RESPONSE_RESET" });
}

export function* getSagaCouponList() {
  yield takeEvery("GET_LIST_COUPON", getCouponList);
}

export function* sagaCreateCoupon() {
  yield takeEvery("CREATE_COUPON", createCoupon);
}

export function* sagaUpdateCoupon() {
  yield takeEvery("UPDATE_COUPON", updateCoupon);
}

export function* getSagaCoupon() {
  yield takeEvery("GET_COUPON", getCoupon);
}

export function* resetSagaCoupon() {
  yield takeEvery("RESET_COUPON", resetCoupon);
}

export function* getCouponCodeDetail() {
  yield takeEvery("GET_COUPON_CODE_DETAIL", getCouponCode);
}

export function* updateCouponCodeDetail() {
  yield takeEvery("UPDATE_COUPON_CODE_DETAIL", updateCouponCode);
}

export function* resetCouponCodeDetail() {
  yield takeEvery("RESET_COUPON_CODE_DETAIL", resetCouponCode);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
